export function ApiNotActive() {
  return (
    <div className="sk:flex sk:min-h-[calc(100vh_-_80px)] sk:flex-col sk:items-center sk:gap-6 sk:px-4 sk:pt-40 sk:pb-4 sk:text-center">
      <div className="sk:flex sk:flex-col sk:gap-3">
        <h1 className="sk:m-0 sk:text-[40px] sk:leading-[47px] sk:font-bold sk:text-fg">
          We&apos;re making improvements!
        </h1>
        <p className="sk:m-0 sk:text-xl sk:font-light sk:text-fg-secondary">
          Please bear with us while we update the server.
        </p>
        <p className="sk:m-0 sk:text-xl sk:font-light sk:text-fg-secondary">
          Thank you for your patience!
        </p>
      </div>
      <img src="/cat.svg" alt="" className="sk:h-auto sk:max-w-full" />
    </div>
  );
}
